import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check, Sparkles } from "lucide-react";
import { useAuth } from "../lib/auth";
import { api } from "../lib/api";
import { toast } from "sonner";

const PERKS = [
  "Boutique référencée sur la carte interactive",
  "Épingle colorée dans votre catégorie",
  "Fiche détaillée : description, site, adresse, contact",
  "Visibilité auprès d'une audience curve engagée",
  "Renouvellement automatique — annulable à tout moment",
  "Article de mise en avant dans le blog",
];

export default function Subscription() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);

  const onSubscribe = async () => {
    if (!user) {
      toast.info("Connectez-vous d'abord pour vous abonner");
      nav("/connexion");
      return;
    }
    setBusy(true);
    try {
      const r = await api.post("/payments/checkout", { origin_url: window.location.origin });
      window.location.href = r.data.checkout_url;
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur de paiement");
      setBusy(false);
    }
  };

  return (
    <main className="max-w-4xl mx-auto px-6 md:px-8 py-16 md:py-24" data-testid="subscription-page">
      <div className="text-center">
        <span className="eyebrow">Abonnement Boutique</span>
        <h1 className="font-heading mt-4 text-[var(--agt-navy)]" style={{ fontSize: "clamp(2.5rem, 6vw, 4.5rem)" }}>
          Référencez votre boutique<br/>
          <span className="font-heading-accent text-[var(--agt-mustard-deep)]">sur la plus belle carte</span><br/>
          curve de France.
        </h1>
        <p className="mt-8 text-lg text-[var(--agt-ink-muted)] max-w-2xl mx-auto leading-relaxed">
          Un seul plan, simple et transparent. Renouvellement automatique — vous pouvez arrêter quand vous voulez.
        </p>
      </div>

      <div className="mt-14 max-w-lg mx-auto">
        <div className="relative bg-white border-2 border-[var(--agt-line)] p-10 rounded-[32px] shadow-2xl">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[var(--agt-mustard)] text-[var(--agt-navy)] px-6 py-2 text-xs font-bold uppercase tracking-widest rounded-full">
            ★ Recommandé
          </div>

          <span className="eyebrow-navy">Plan Annuel</span>
          <div className="mt-5 flex items-baseline gap-2">
            <span className="font-heading text-8xl leading-none text-[var(--agt-navy)]">30<span className="text-4xl text-[var(--agt-mustard-deep)]">€</span></span>
          </div>
          <p className="text-xs uppercase tracking-widest text-[var(--agt-ink-muted)] mt-3 font-bold">/ an · renouvellement auto</p>

          <div className="h-px bg-[var(--agt-line)] my-8"/>

          <ul className="space-y-4">
            {PERKS.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <span className="w-6 h-6 rounded-full bg-[var(--agt-mustard)] grid place-items-center flex-shrink-0 mt-0.5">
                  <Check className="w-3.5 h-3.5 text-[var(--agt-navy)]" strokeWidth={3}/>
                </span>
                <span className="text-base text-[var(--agt-navy)]">{p}</span>
              </li>
            ))}
          </ul>

          <button
            onClick={onSubscribe}
            disabled={busy}
            data-testid="subscribe-btn"
            className="btn-primary w-full justify-center mt-10"
          >
            <Sparkles className="w-4 h-4"/> {busy ? "Redirection…" : "S'abonner — 30€/an"}
          </button>

          <p className="mt-5 text-xs uppercase tracking-widest text-[var(--agt-ink-muted)] text-center font-bold">
            Paiement sécurisé via Stripe · CB acceptée
          </p>
        </div>
      </div>

      <div className="mt-16 text-center text-base text-[var(--agt-ink-muted)] max-w-xl mx-auto">
        <strong className="text-[var(--agt-navy)]">Vous êtes une association ou un particulier ?</strong><br/>Contactez-nous, le référencement peut être offert selon votre projet.
      </div>
    </main>
  );
}
